import {
  KoAffix,
  KoButton,
  KoCard,
  KoDateFormatter,
  KoDescription,
  KoDP,
  KoEmpty,
  KoFlex,
  KoForm,
  KoFormBuilder,
  KoLoader,
  KoModal,
  KoNano,
  KoSelect,
  KoTag,
  KoText,
  KoTitle,
  KoToast,
  KoTooltips
} from 'packages';
import KoIcon from '@kwapio/icons';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { add, remove } from 'shared/store/breadcrumbSlice';
import KoToolBar from 'shared/components/toolbar';
import { getCookie, setCookie } from 'shared/utils/cookies';
import styles from './workspace.module.scss';
import { workspaceAPI } from './workspace.service';
import { canWorkspaceCreate } from 'layouts/permissions';
import WorkspaceCurd from './workspacecurd';
import { getWorkspace } from 'shared/store/workspaceSlice';
import Templates from './templates';
import ReadOnlyWorkflowEditor from 'packages/workflow/readonlyWorkflow';
import { generateKey } from 'shared/utils';
function Workspace() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const accountId = getCookie("accountId");
  const [templateViewOnly, setTemplateViewOnly] = useState(false);
  const [custmersList, setDataList] = useState();
  const [currentRecord, setCurrentRecord] = useState();
  const [isLoading, setLoading] = useState(false);
  const [isOpenDelete, setDeleteModal] = useState(false);
  const {data, state} = useSelector((state) => state.workspace);
  const [workspaceList, setWorkspaceList] = useState(data);
  const [isCustomerModalOpen, setCustomerModal] = useState(false);
  const [copy, setCopy] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);
  const [isTemplateModal, setTemplateModal] = useState(false);
  const [currentTemplate, setCurrentTemplate] = useState();
  const [currentWorkspace, setCurrentWorkspace] = useState();
  const [, setActiveSegment] = useState('Workflow');
  const [templateSelected, setTemplateSelected] = useState();
  const userById = useSelector(state => state?.userById);
  let userDetails = userById['data'];
  const [form] = KoForm.useForm();
  const [wosForm] = KoForm.useForm();
  const [cusForm] = KoForm.useForm();

  useEffect(() => {
    dispatch(remove());
    dispatch(add([]));
    getWorkspaces();
  }, []);

  useEffect(() => {
    getClients();
    if(data){
      setWorkspaceList(data);
    }
  }, [data]);

  const getClients = () => {
    setLoading(true);
    workspaceAPI.getClients().then(
      (data) => {
        setLoading(false);
        setDataList(data['customers']);
      },
      (err) => {
        setLoading(false);
      }
    );
  };


  const getWorkspaces = (isClose) => {
    setLoading(true);
    dispatch(getWorkspace());
    if(state === "success"){
      setLoading(false);
    }
    if(isClose){
      setCurrentRecord();
      setOpenSettings(false);
    }
   
  };

  const handleFinishDelete = () => {
    setLoading(true);
    workspaceAPI.deleteById(currentRecord?.workspaceId).then(
      (data) => {
        getWorkspaces();
        setLoading(false);
        setDeleteModal(false);
        if(data?.message !== 'success'){
          KoToast.error(data?.message + 'Contact admin');
        }else{
          KoToast.success(`workspace deleted successfully! ${currentRecord?.name}!`);
        }
       
      },
      (err) => {
        setLoading(false);
        KoToast.error(`error`);
      }
    );
  };


  const onCopyPublicUrl = (text) => {
    setCopy(true);
    navigator.clipboard.writeText(`${text}`);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (copy) setCopy(false);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [copy]);


  const onAction = (key, workspace) => {
    setCurrentWorkspace(workspace);
    if (key === "1") {
      setOpenSettings(true);
    } else {
      setDeleteModal(true);
    }
  };

  const setWorkspace = (wos) => {
    setCookie('wos', wos?.workspaceId || wos?.workSpace);
  };

  const serachWorkspace = (searchText) => {
    if(searchText){
      let wors = workspaceList?.filter((item) => item?.name?.toLowerCase().includes(searchText?.toLowerCase()));
      setWorkspaceList(wors);
    }else{
      setWorkspaceList(data);
    }
  };


  const KeyColor = (bgColor) => {
    const isColorDark = (color) => {
      const hex = color.replace("#", "");
      const [r, g, b] = [parseInt(hex.substr(0, 2), 16), parseInt(hex.substr(2, 2), 16), parseInt(hex.substr(4, 2), 16)];
      const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
      return luminance < 128;
    };

    return {
      backgroundColor: bgColor,
      color: isColorDark(bgColor) ? "#ffffff" : "#000000"
    };
  };

  const openTemplates = (source) => {
    if(source === 'view'){
      setTemplateViewOnly(true);
    }else{
      setTemplateViewOnly(false);
    }
    setTemplateModal(true);
  };


  const handleSubmitCustomer = (values) => {
    setLoading(true);
    values['customerId'] = KoNano('CUS');
    workspaceAPI.createOrUpdateCompany(values, "CLI3103B7FE26").then(
      (data) => {
        getClients();
        form.setFieldsValue({ customer: values.customerId });
        KoToast.success('Customer created successfully');
        setCustomerModal(false);
        cusForm.resetFields();
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };


  const Customer = ({ value, onChange }) =>
    <KoSelect value={value}
      showSearch
      onChange={v => { onChange(v); }}
      placeholder='Select customer'
      options={custmersList?.map((cus) => ({
        label: cus?.companyName,
        value: cus?.customerId
      }))}
    />;

  const formMeta= {
    columns: 6,
    formItemLayout: null,
    initialValues: currentRecord,
    colon: true,
    fields: [
      {
        key: 'name', label: 'Name', colSpan: 6,
        placeholder: 'Enter workspace name',
        rules: [
          {
            required: true,
            message: `Enter new workspace name.`
          }
        ]
      },
      {
        key: 'customer', label: <div className={styles.assigneeLabel}>
          <KoText text={'Customer'} />
          <KoText className={styles.assignToMe} text={'(Or Add New)'} onClick={() => setCustomerModal(true)} />
        </div>, colSpan: 6,
        widget: Customer,
        rules: [
          {
            required: true,
            message: `Select a customer.`
          }
        ]
      }
    ]
  };

  const meta = {
    columns: 4,
    formItemLayout: null,
    colon: true,
    fields: [
      {
        key: 'companyName', label: 'Customer / Company Name', colSpan: 4,
        placeholder: 'Enter customer / company name',
        rules: [
          {
            required: true,
            message: `Enter customer / company name.`
          }
        ]
      }
    ]
  };

  const handleFinish = (values => {
    setLoading(true);
    values['workspaceId'] = KoNano('WOS');
    values['key'] = generateKey(values.name);
    workspaceAPI.createOrUpdateClient(values).then(
      (data) => {
        setLoading(false);
        updateWorkflow(values?.workspaceId);
        wosForm.resetFields();
        KoToast.success('Workspace created successfully');
      },
      (err) => {
        setLoading(false);
      }
    );
  });

  const updateWorkflow = (wosId) => {
    setLoading(true);
    workspaceAPI.updateWorkflow(currentTemplate, currentTemplate?.templateId, wosId).then(
      (data) => {
        setLoading(false);
        getWorkspace&& getWorkspace();
        setOpenSettings(false);
        navigate(`/workspace/${wosId}/${currentTemplate?.type?.toLowerCase()}/dashboard`);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  return <div className={styles.wrapper}>
    {isLoading && <KoLoader />}
    <KoAffix top={56}>
      <KoToolBar
        className={styles.toolbar}
        backBtn={true}
        title={'Workspace'}
        search={{ visible: true, onChange:serachWorkspace, placeholder: 'Search by project name' }}
        visible={canWorkspaceCreate(userDetails?.roles)}
        canCreate={false}
        buttonList={[{
          label: 'Templates',
          color:'purple',
          variant: 'outlined',
          icon: <KoIcon color="#9154DE"  name="ChangeTemplateOutlined" width={18} height={18} />,
          onClick: ()=>openTemplates('view'),
          disabled: !canWorkspaceCreate(userDetails?.roles)
        }, {
          label: 'Create Workspace',
          type: 'primary',
          icon: <KoIcon color="#FFF" name="PlusOutlined" width={18} height={18} />,
          onClick: () => {setCurrentWorkspace(); openTemplates('view'); form.resetFields(); },
          disabled: !canWorkspaceCreate(userDetails?.roles)
        }]} />
    </KoAffix>
    {workspaceList?.length > 0 ? <KoFlex wrap="wrap" gap="small" className={styles.listSection}>
      {workspaceList?.map((workspace, i) =>
        <KoCard onClick={() => {setWorkspace(workspace); setCurrentRecord(workspace);}} className={styles.card}
          key={workspace?.workspaceId}
          hoverable={true}>
          <div className={styles.aLink}>
            <div onClick={() => navigate(`/workspace/${workspace?.workspaceId}/${workspace?.template?.type.toLowerCase() || 'development'}/dashboard`)}>
              <div className={styles.titleKey}>
                <div className={`${styles.headCircle}  ${workspace?.customerDetails?.companyName ?
                  workspace?.customerDetails?.companyName?.charAt(0).toLowerCase() : 'a'}`}>
                  {workspace?.customerDetails?.['logo'] ?
                    <KoDP shape={'default'} logo={workspace?.customerDetails?.['logo']} width={25} height={'auto'} />
                    :
                    <KoText className={`${styles.letter}`} text={workspace?.name?.charAt(0)} />
                  }
                </div>
                <div className={styles.titleValue}>
                  <div className={styles.verified}>
                    <KoText ellipsis={true} className={`${styles.text}`} text={workspace?.name} />
                  </div>
                  <KoTitle className={styles.title} ellipsis={true} text={workspace?.customerDetails?.companyName} level={4} />
                </div>
              </div>
              <KoText style={workspace?.color && KeyColor(workspace?.color)} className={`${styles.key} ${!workspace?.color && styles[workspace?.key ? workspace?.key?.charAt(0).toLowerCase() : 'a']}`}
                text={`${workspace?.key}`} />
              <div className={styles.description} >
                <KoDescription className={styles.span} text={`${workspace?.description ? workspace?.description : '-'}`} ellipsis={{
                  rows:2
                }} />
              </div>
            </div>
            <div className={styles.wostag}>
              {workspace?.template?.type === 'Development' && <KoTag custom={true} iscount={false} color={`color-1`} value={workspace?.template?.type} />}
              {workspace?.template?.type === 'Events' && <KoTag custom={true} iscount={false} color={`color-9`} value={workspace?.template?.type} />}
              { workspace?.template?.type === 'Orders' && <KoTag custom={true} iscount={false} color={`color-2`} value={workspace?.template?.type} />}
              {workspace?.template?.type === 'Sales' && <KoTag custom={true} iscount={false} color={`color-3`} value={workspace?.template?.type} />}
              { workspace?.template?.type === 'Marketing' && <KoTag custom={true} iscount={false} color={`color-4`} value={workspace?.template?.type} />}
              {workspace?.template?.type === 'Support' && <KoTag custom={true} iscount={false} color={`color-5`} value={workspace?.template?.type} />}
              {workspace?.template?.type === 'HR' &&  <KoTag custom={true} iscount={false} color={`color-6`} value={workspace?.template?.type} />}
              {workspace?.template?.type === 'Helpdesk' && <KoTag custom={true} iscount={false} color={`color-7`} value={workspace?.template?.type} />}
              {workspace?.template?.type === 'Finance' && <KoTag custom={true} iscount={false} color={`color-8`} value={workspace?.template?.type} />}
              {workspace?.template?.type === 'Assets' && <KoTag custom={true} iscount={false} color={`color-9`} value={workspace?.template?.type} />}

            </div>
            <div className={styles.link}>
              <div className={styles.row}>
                <KoText className={styles.date} text='Created on' />
                <KoDateFormatter format='DD-MMM-YYYY' data={workspace?.createdAt} className={styles.date} />
              
              </div>
              {
                userDetails?.roles?.some((role) => [1, 2, 4].includes(role)) &&
                <div className={styles.workspaceLink}>
                  {workspace?.isPublic && (
                    <KoTooltips title={copy ? 'Copied' : 'Copy Public Url'}>
                      <KoButton
                        className={styles.copyBtn}
                        onClick={() =>onCopyPublicUrl(`${window.location.origin}/open/${accountId}/b2c`)}
                        iconBtn={true}
                        icon={<KoIcon width={14} height={14} name="CopyOutlined" />}
                      />

                    </KoTooltips>
                  )}
                  <KoTooltips title={'Edit workspace'}>
                    <KoButton className={styles.copyBtn} onClick={() => {setCurrentRecord(workspace); onAction('1', workspace);}} iconBtn={true} icon={<KoIcon width={14} height={14} name={'EditOutlined'} />} />
                  </KoTooltips>
                  <KoTooltips title={'Delete workspace'}>
                    <KoButton  className={styles.copyBtn} onClick={() => {setCurrentRecord(workspace);onAction('4', workspace);}} iconBtn={true} icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />} />
                  </KoTooltips>
                </div>
              }
            </div>
          </div>
        </KoCard>
      )}
    </KoFlex> :
      <KoFlex wrap="wrap" gap="small" className={styles.emptySection}>
        <KoEmpty onClick={() => openTemplates('view')} label="Create Workspace" icon={'EmptyTwoTone'} title="Create a new workspace" />
      </KoFlex>
    }
    {/* {workspaceList?.length > 0 && <div className='tableCard'>
      <KoToolBar
        className={styles.toolbar}
        title={'Recent works'}
        search={{ visible: true, onChange: onSearchText, placeholder: 'Search by any parameter' }}
        filter={{
          visible: false,
          options: [{ label: 'Sort By Name', key: '0' },
            { label: 'Created At', key: '2' },
            { label: 'Sort By designation', key: '3' }]
        }}
        buttonList={[]} />

      <div className={styles.reacentTable}>
        <KoTable rowKey='ticketId'
          onSort={onSort}
          onCellClick={onCellClick}
          data={{ columns: PRO_ITEMS_COLUMNS, rows: recent }}
          extraColumnsRight={columnsRight} maxHeight={100} />
        <KoPagination current={parseInt(pagination.page) || 1}
          total={totalCount}
          showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} records`
          }
          pageSize={pagination.limit}
          defaultCurrent={pagination.page}
          onChange={onPagination}
          showQuickJumper={false}
          simple={false}
          responsive={false} />
      </div>
      {isCommnetsModalOpen && <CommnetsModal
        setCreateComment={setCreateComment}
        isCommentsModal={isOpenCommentsModal}
        classNameMain={styles.wrapperOverflow}
        isCommnetsModalOpen={isCommnetsModalOpen}
        setCommnetsModal={() => setCommnetsModal(false)}
        currentRecord={currentRecord}
        setCurrentRecord={setCurrentRecord}
        workspaceId={currentRecord?.workspaceId}
        ticketId={currentRecord?.ticketId} />}
    </div>} */}

    <KoModal
      title={`Delete workspace ${currentRecord?.name?.toUpperCase()}`}
      centered
      open={isOpenDelete}
      handleOk={() => { setCurrentRecord(); setDeleteModal(false); }}
      onClose={() => { setCurrentRecord(); setDeleteModal(false); }}
      width={580}
      footer={[
        <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(!isOpenDelete)} />,
        <KoButton key='reset' loading={isLoading} color="danger" variant="solid"  type='primary' label='Delete' onClick={() => handleFinishDelete()} />
      ]}
    >
      {isLoading && <KoLoader circle={false} />}
      <div className={styles.suspend}>
        <KoTitle level={5} text={`Are you sure you want to delete this workspace?`} />
        <KoText text={`This action is irreversible, and it will result in the removal of their associated data and Kwapio license.`} />
      </div>
    </KoModal>

    {openSettings && <WorkspaceCurd
      openSettings={openSettings}
      setOpenSettings={setOpenSettings}
      getWorkspace={getWorkspaces}
      currentWorkspace={currentWorkspace}
      selectedTemplate={currentTemplate}
      openTemplates={openTemplates}
    />}

    <KoModal
      title={`Workspace templates`}
      centered
      open={isTemplateModal}
      handleOk={() => { setTemplateModal(false); }}
      onClose={() => { setTemplateModal(false); }}
      width={'95vw'}
      footer={[
        <KoButton key='cancel' label='Cancel' onClick={() => {setTemplateModal(false);}} />,
        (!currentTemplate?.isDefault ) && <KoButton key='Submit' type='primary' label='Save Template' onClick={() => {form.submit();}} />,
        (currentTemplate?.templateId ===1 || currentTemplate?.templateId ===20 || currentTemplate?.templateId ===21) &&  <KoButton key='create' disabled={!currentTemplate}  loading={isLoading} onClick={() => {templateSelected ? wosForm.submit() : setTemplateSelected(true);}} type='primary' label={templateSelected ? `Create Wokspace` :  'Use Template' } />,
        (currentTemplate?.templateId !==1 && currentTemplate?.templateId !==20 && currentTemplate?.templateId !==21) && <KoButton key='request' loading={isLoading} onClick={() => { window.open("https://kwapio.com/request/", "_blank");}} color='blue' variant='solid' label={'Request for demo'} />
        
      ]}
    >
      {isLoading && <KoLoader circle={false} />}
      {!templateSelected &&  <Templates readOnly={templateViewOnly} form={form} onSetTemplate={setCurrentTemplate} setActiveSegment={setActiveSegment}/>}
      {templateSelected &&  <div className={styles.createWorkspace}>
        <div className={styles.headerCreate} onClick={() => setTemplateSelected(false)}>
          <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'ArrowLeftOutlined'} />} />
          <KoText text={'Back to workspace templates'} />
        </div>
        <div className={styles.formWrapper}>
          <div className={styles.form}>
            <KoForm form={wosForm} layout="vertical" onFinish={handleFinish}>
              <KoFormBuilder  form={wosForm} meta={formMeta} />
            </KoForm>
          </div>
          <div className={styles.preview}>
            <div className={styles.circle1}>
            </div>
            <div className={styles.circle2}>
            </div>
            <div className={`${styles.workflowTree} tableCard`}>
              <ReadOnlyWorkflowEditor  workspace={currentRecord} setTemplateModal={setTemplateModal} data={currentTemplate} height={'calc(100vh - 45rem)'}/>
            </div>
          </div>
        </div>
      </div>}
    </KoModal>
    <KoModal
      title={`Create new Customer`}
      open={isCustomerModalOpen}
      width={'40%'}
      centered
      onClose={() => setCustomerModal(false)}
      footer={[
        <KoButton key='cancel' label='Cancel' onClick={() => setCustomerModal(false)} />,
        <KoButton key='create' type='primary' label={`Create`}
          onClick={() => cusForm.submit()} />
      ]}
    >
      <div className={styles.customerName}>
        {isLoading && <KoLoader />}
        <KoForm form={cusForm} layout="vertical" onFinish={handleSubmitCustomer}>
          <KoFormBuilder form={cusForm} meta={meta} />
        </KoForm>
      </div>
    </KoModal>
  </div>;
}

export default Workspace;
